import Box, { BoxProps } from "@mui/material/Box";
import * as React from "react";

export interface AccountPopoverFooterProps extends BoxProps {
  children?: React.ReactNode;
}

function AccountPopoverFooter(props: AccountPopoverFooterProps) {
  const { children, ...rest } = props;
  return (
    <Box
      {...rest}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        p: 1,
        justifyContent: "center",
        ...rest.sx,
      }}
    >
      {children}
    </Box>
  );
}

export { AccountPopoverFooter };
